import {connect} from "react-redux";
import RankingPanel from "./RankingPanel.jsx";
import {fetchPageAction, searchAction} from "../Core/myResultsActions";

const mapStateToProps = (state) => {
    return {
        page: state.ranking.page,
        pagesTotal: state.ranking.pagesTotal,
        classification: state.classifications.current,
        search: state.ranking.search,
        game: state.games.current,
        noEntries: !state.ranking.entries.length,
        hide: state.subleagues.openList || state.subleagues.openEntries
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onPageClick: (classification, pageIndex, search) => dispatch(fetchPageAction(classification, pageIndex, search)),
        onSearch: (classification, search) => dispatch(searchAction(classification, search))
    }
};

const RankingTableContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RankingPanel);

export default RankingTableContainer